import "./input_image.scss";
import IconUpload from "../../assets/icons/icon_upload.svg";
import IconCloseImage from "../../assets/icons/icon_close_image.svg";
import IconPreviewImage from "../../assets/icons/icon_preview_image.svg";
import { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import CustomModal from "../custom_modal";
import Button from "../button";

const InputImage = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);
  useEffect(() => {
    if (props.value) {
      setPreview(props.value);
    }
  });

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    props.onChange(file);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const removePreview = () => {
    if (props.removePreview) {
      props.removePreview();
    }
    setPreview(null);
    fileInputRef.current.value = null;
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <div className={`form-group ${props.label ? "m-1" : ""}`}>
        {props.label ? (
          <label htmlFor={props.id}>
            {props.label}{" "}
            {props.required && <span style={{ color: "red" }}>(*)</span>}
          </label>
        ) : null}
        <input
          type="file"
          ref={fileInputRef}
          multiple={props.isMultiple ?? false}
          onChange={handleChange}
          style={{ display: "none" }}
        />
        {preview ? (
          <div className="preview-upload">
            <img src={preview} alt="gambar preview" className="image-preview" />
            <div className="preview-modal-button">
              <img
              alt="icon preview"
                onClick={() => openModal()}
                src={IconPreviewImage}
                className="icon-preview"
              />
            </div>
            <div
              className="close-preview"
              style={{ position: "absolute", top: "4px", right: "4px" }}
            >
              <img src={IconCloseImage} alt="close preview" onClick={() => removePreview()} />
            </div>
          </div>
        ) : (
          <>
            <div className="custom-file-input" onClick={handleClick}>
              <img src={IconUpload} alt="upload icon" className="icon-upload" />
              <div className="text-upload">Browse files</div>
            </div>
            <div className="text-validasi">The file must be in ZIP format.</div>
          </>
        )}
      </div>
      <CustomModal
        withHeader={false}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <img
          src={preview}
          alt=""
          style={{ width: "auto", height: "65vh", objectFit: "contain" }}
        />
      </CustomModal>
    </>
  );
};
export default InputImage;
